export const AREA = [
    { label: 'Favela', value: 'Shantytown' },
    { label: 'Comunidade', value: 'Community' },
    { label: 'Ocupação', value: 'Occupation' },
    { label: 'Quiombo', value: 'Quilombo' },
    { label: 'Vila', value: 'Village' },
    { label: 'Povoado', value: 'Settlement' },
    { label: 'Outro', value: 'Other' }
];